import { TBeaconEntry } from '@ixicare/resources';
import { SortAccessor } from '../types';

export type BeaconSortAccessor = SortAccessor<TBeaconEntry>;

export const beaconSortAccessors: Record<string, BeaconSortAccessor> = {
  id: (b) => b.id,
  mac_address: (b) => b.macAddress,
  description: (b) => b.description ?? null,
  created: (b) => b.created?.getTime() ?? null,
  battery_level: (b) => b.batteryLevel ?? null,
  installation_zone: (b) => b.zone?.name ?? null,
  calibration_factor: (b) => b.calibrationFactor ?? null,
  last_seen: (b) => b.lastSeen?.getTime() ?? null,
  state: (b) => b.billingState ?? null,
};
